import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StateService } from '@/core/services/state.service';
import { NavigationItem } from '@/core/models/navigation-item.model';
import { AbschnittDisplayModel, AnfrageDisplayModel, LocalizedTextDisplayModel } from '@/api/model-index';
import { I18nService } from '@/core/services/i18nService';
import { GutachtenDisplayModel } from '../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/gutachten-display-model';
import { PortalkonfigurationDisplayModel } from '../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { PortalContextService } from '../../../../services/portal-context.service';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { FormularService } from '../../../../services/formular.service';
import { NavigationService } from '../../../../services/navigation.service';
import { AnfrageService } from '@/api/service-index';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-review-detail',
  templateUrl: './app-review-detail.component.html',
  styleUrls: ['./app-review-detail.component.scss']
})
export class AppReviewDetailComponent implements OnInit {
  protected _navItemList: NavigationItem[] | null;

  public review: GutachtenDisplayModel | null;
  public portalkonfiguration: PortalkonfigurationDisplayModel;

  public get showProzessNavigation() {
    return this.stateService.showProzessNavigation;
  }

  public get showAnfrageInfo() {
    return this.stateService.showAnfrageInfo;
  }

  public get showAbsenden(): boolean {
    return !this.portalContextService.isAnfrageDisabled();
  }

  public get isFormEnabled(): boolean {
    return !this.portalContextService.isAnfrageDisabled();
  }

  public get GetAbsendenText(): LocalizedTextDisplayModel[] {
    var list = this.languageservice.supportedLanguages.map(lang => {
      let text = new LocalizedTextDisplayModel();
      text.text = this.languageservice.instantForSpecificLanguage('submitdialogue.submit_send', lang)
      lang = lang.split('-')[0];
      text.localeCode = lang;
      return text;
    })
    return list;
  }

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected languageservice: I18nService,
    protected portalContextService: PortalContextService,
    protected loadingAnimationService: LoadingAnimationService,
    protected formularService: FormularService,
    protected navigationService: NavigationService,
    protected anfrageService: AnfrageService) {

    this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;
    this.review = this.portalContextService.CurrentGutachten;

    this.stateService.ValidationErrors = this.route.snapshot.data.errors;


    let splittedUrl = this.router.url.split('/');
    let lastUrlSegment = splittedUrl[splittedUrl.length - 1];
    if (this.review?.gutachtenId && lastUrlSegment.includes(this.review?.gutachtenId)) {
      if (this.review.gutachtenPhase && this.review.gutachtenPhase.abschnitte) {
        this.loadingAnimationService.hide();
        let link = this.formularService.getRouteObjectThrough(this.review?.gutachtenPhase?.abschnitte[0]).link.split("/");

        let sectionType = link[0];
        let sectionId = link[1];
        this.router.navigate([sectionType, sectionId], { relativeTo: this.route });
      }
    }

    this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.portalContextService.CurrentAnfrage.id, gutachtenId: this.review?.gutachtenId ?? undefined }).subscribe(data => {
      this.stateService.ValidationErrors = data;
    });
  }

  // nullReference is used to set the CurrentAnfrage to null when leaving the page to avoid: Type 'null' is not assignable to type 'AnfrageDisplayModel'.
  protected nullReference: AnfrageDisplayModel;
  ngOnDestroy(): void {
    //CurrentGutachten kann vom Typ her niemals null sein, beim Verlassen sollte es aber auf null gesetzt werden, darum dieser Trick hier
    this.portalContextService.CurrentGutachten = null;
    this.portalContextService.CurrentAnfrage = this.nullReference;
    this.stateService.ValidationErrors = null;
  }

  public get navItemList() {
    return this._navItemList;
  }

  ngOnInit(): void {
    this._navItemList = this.navigationService.getNavItems(this.review?.gutachtenPhase?.abschnitte);
    this._navItemList?.forEach(navItem => {
      navItem.children = this.navigationService.getNavItems(navItem.childAbschnitte);
    });
  }

  public isCurrentRoute(parentAbschnitt: AbschnittDisplayModel, childAbschnitt?: AbschnittDisplayModel) {
    let abschnittId: string | null = <string>this.route.firstChild?.snapshot.params['abschnittid'];

    if (!abschnittId) return false;

    // Parent is active
    if (parentAbschnitt.id == abschnittId && !childAbschnitt) {
      return true;
    }

    if (childAbschnitt && childAbschnitt.id == abschnittId) {
      return true;
    }

    return false;
  }

  public isDataprotectionRoute() {
    let urlSegments = this.router.url.split("/");

    if (urlSegments.includes("dataprotection"))
      return true;

    return false;
  }

  public isParentOpen(parentAbschnitt: AbschnittDisplayModel) {
    let abschnittId: string | null = <string>this.route.firstChild?.snapshot.params['abschnittid'];
    let isOpen = false;

    // If parent is active and has children
    if (parentAbschnitt.abschnitte && this.isCurrentRoute(parentAbschnitt)) {
      isOpen = true;
    }

    // If a child was found in parent, then show group
    let childAbschnitt = parentAbschnitt.abschnitte?.find(a => a.id == abschnittId);
    if (childAbschnitt) {
      isOpen = true;
    }

    return isOpen;
  }

  public isChildAbschnittNotValid(parentAbschnitt: AbschnittDisplayModel) {
    if (parentAbschnitt.abschnitte) {
      for (let i = 0; i < parentAbschnitt.abschnitte?.length; i++) {
        if (this.getStatusFor(parentAbschnitt.abschnitte![i].id) == 0)
          return true;

      }
    }
    return false;
  }

  public getStatusFor(abschnittId: string | undefined): number {
    if (!abschnittId)
      return 0;

    //Wenn es keine Validierungsfehler gibt, dann ist der Abschnitt valide
    if (abschnittId == 'dataprotection'
      || !this.stateService.ValidationErrors
      || !this.stateService.ValidationErrors[abschnittId]
      || this.stateService.ValidationErrors[abschnittId].length == 0)
      return 1;

    return 0;
  }
}
